<mat-toolbar>
  <span class="spacer"></span>
  <button mat-raised-button (click)="waxLogin()" *ngIf="!waxService.userAccount">Log In with Cloud Wallet</button>
  <button mat-raised-button (click)="scatterLogin()" *ngIf="!waxService.userAccount">Log In with Scatter</button>
  <button mat-raised-button (click)="anchorLogin()" *ngIf="!waxService.userAccount">Log In with Anchor</button>
  <span *ngIf="waxService.userAccount">{{waxService.userAccount}}</span>
</mat-toolbar>
<div *ngIf="(packInventory$ | async) as inventory">
  <h2>Open packs</h2>
  Don't leave the page after opening to also validate claiming !<br>
  <mat-form-field>
    <mat-select #packSelect>
      <mat-option *ngFor="let pack of inventory" [value]="pack">
        {{pack.name}} #{{pack.template_mint}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-raised-button (click)="unboxPack(packSelect.value)" [disabled]="!waxService.userAccount || !packSelect.value">{{waxService.userAccount ? 'Unbox' : 'Login first !'}}</button>
  <br><br>
  <div *ngIf="(recipes$ | async) as recipes">
    <h2>Craft cards</h2>
    <mat-form-field>
      <mat-select (valueChange)="recipeSelected($event, inventory)" #recipeSelect>
        <mat-option *ngFor="let recipe of recipes" [value]="recipe">
          {{recipe.recipe_display}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <span>{{recipeCost}}</span>
    <button mat-raised-button (click)="craft(recipeSelect.value)" [disabled]="!waxService.userAccount || !recipeSelect.value">{{waxService.userAccount ? 'Craft' : 'Login first !'}}</button>
  </div>
</div>
